export default {
  iconTextItem: ['Total', 'icons'],
}
